export default __webpack_public_path__ + "8cccdd2a4858d58c1304f3ea0a09e577.png";